import React from "react";
import "./Footer.css";
import Images from "../../assets/images";
import { ImLocation2 } from "react-icons/im";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import nobelLogo from "../../assets/images/nobel_logo.png";

export const Footer = ({ setActiveLink }) => {
  const handleFooterLinkClick = (link) => {
    setActiveLink(link);
    window.scrollTo(0, 0);
  };

  return (
    <div className="footer-main-container">
      <div
        className="footer-container"
        style={{
          backgroundImage: Images.footer,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="footer-description">
          <p>
            Nobel AI Legal is transforming how Personal Injury Lawyers handle
            Accident Benefits and TORT Claims. Founded in 2025, our AI-powered
            platform replaces outdated methods with real-time data sharing for
            faster, more accurate, and client-focused case resolutions.
          </p>
        </div>
        <div className="footer-address">
          <h3>Address</h3>
          <p>
            <ImLocation2 className="footer-logo-style" size={30} />
            <a
              href="https://maps.app.goo.gl/AAmvqPd6CoSw6Kjp9"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              4551 Zimmerman Avenue, Niagara Falls, Ontario LZE 3M5, Canada
            </a>
          </p>
          <p>
            <FaPhoneAlt className="footer-logo-style" size={20} />
            <a href="tel:+16476133478" className="footer-link">
              +1 647 613 3478
            </a>
          </p>
          <p>
            <MdEmail className="footer-logo-style" size={20} />
            <a href="mailto:Halil@nobelailegal.com" className="footer-link">
              Halil@nobelailegal.com
            </a>
          </p>
          <p className="nohover-style">
            <MdOutlineAccessTimeFilled
              className="footer-logo-style"
              size={20}
            />
            07:15AM to 5:30PM
          </p>
        </div>
        <div className="footer-quick-links">
          <h3>Services</h3>
          <a
            href="/contact"
            onClick={() => handleFooterLinkClick("pressAndMedia")}
          >
            <GoDotFill className="footer-logo-style" size={15} />
            Case Management Platform
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("gallery")}>
            <GoDotFill className="footer-logo-style" size={15} />
            Lead Management
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("gallery")}>
            <GoDotFill className="footer-logo-style" size={15} />
            Contract Management
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("gallery")}>
            <GoDotFill className="footer-logo-style" size={15} />
            Business Analytics
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("gallery")}>
            <GoDotFill className="footer-logo-style" size={15} />
            eSignatures
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("gallery")}>
            <GoDotFill className="footer-logo-style" size={15} />
            Time, Billing & Payments
          </a>
          <a href="/contact" onClick={() => handleFooterLinkClick("contactus")}>
            <GoDotFill className="footer-logo-style" size={15} />
            Document Management
          </a>
        </div>
        <div className="footer-map">
          <div className="footer-map-container">
            <img
              src={nobelLogo}
              alt="Nobel AI Legal Logo"
              className="footer-logo"
            />
          </div>
        </div>
      </div>
      <footer>
        <p>© Copyright 2025 Nobel AI Legal. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default Footer;
